const General = {
    routes: {
        home: '/',
        login: '/login',
        logout: '/logout',
        animals: '/animals',
        lands: '/lands',
        analysis: '/analysis',
        password: '/password',
        profile: '/profile',
        register: '/register',
        test: '/test',
        users: '/users',
    },
    global: {
        appName: 'Mi Finca',
        alias: 'Alias',
        welcome: 'Welcome to the community',
        loading: 'Loading data...',
        download: 'Download',
        delete: 'Delete',
        menu: 'Menu',
        exit: 'Exit',
        seeDetails: 'See details',
        filter: 'Filter',
        sort: 'Sort',
        total: 'Total',
        true: 'Yes',
        false: 'No',
    },
    date: {
        title: 'Date',
        year: 'Year',
        years: 'Years',
        month: 'Month',
        months: 'Months',
        week: 'Week',
        weeks: 'Weeks',
        day: 'Day',
        days: 'Days',
        daysSinceLast: 'Days since last deliver',
    },
    form: {
        create: 'Create',
        add: 'Add',
        close: 'Close',
        delete: 'Delete',
        description: 'Description',
        edit: 'Edit',
        enter: 'Enter',
        email: 'Email',
        hide: 'Hide',
        name: 'Name',
        open: 'Open',
        password: 'Password',
        save: 'Save',
        saveandclose: 'Save and close',
        apply: 'Apply',
        select: 'Select an option',
        send: 'Send',
        show: 'Show',
        signOut: 'Sing Out',
        submit: 'Submit',
        surname: 'Surname',
        title: 'Title',
        today: 'Today',
        photo: 'Photo',
        addPhoto: 'Add photo',
        changePhoto: 'Change photo',
        photos: 'Photos',
        addPhotos: 'Add photos',
        favPhoto: 'Main photo',
        typeToSearch: 'Type to search',
        helpers: {
            typeToSearch: 'The filter compares from 3 characters without regard to case or position. The filter does not make comparisons by similarity.',
        }
    },
    error: {
        auth_wrong_password: 'Invalid user or password',
        auth_user_not_found: 'Invalid login',
        auth_email_already_in_use: 'Email already in use',
        auth_weak_password: 'Password must be at least 6 characters',
        auth_invalid_email: 'Invalid email',
        passwordMatch: 'Passwords do not match',
        required: 'This field is required',
        default: 'Ups! Something went wrong'
    }
};

export default General;
